export default "__VITE_ASSET__41d38b28__"